import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAppServices, LazyBreadcrumbs, LazyGetStartedBtn, LazyGuideSection, LazyGuideText, LazyLogo, LazyLogoChip, LazyMarketplaceLink, LazyRouteLink, LazyShowUsLove, LazyVArrowBtn, LazyBlockComponent, LazyHtmlBlock, LazyLocalComponentBlock, LazyPageContent, LazySectionBlock, LazyTextBlock, LazyBackgroundBlock, LazyInfoCardBlock, LazyEventBlock, LazyEventsBlock, LazyGridBlock, LazyImageBlock, LazyMediaBlock, LazyVideoBlock, LazyOverlayBlock, LazyProductBlock, LazyProductsBlock, LazyRecipeBlock, LazyRecipesBlock, LazyServiceProfileBlock, LazyServiceProfilesBlock, LazySliderBlock, LazyProseA, LazyProseBlockquote, LazyProseCode, LazyProseEm, LazyProseH1, LazyProseH2, LazyProseH3, LazyProseH4, LazyProseH5, LazyProseH6, LazyProseHr, LazyProseImg, LazyProseLi, LazyProseOl, LazyProseP, LazyProsePre, LazyProseScript, LazyProseStrong, LazyProseTable, LazyProseTbody, LazyProseTd, LazyProseTh, LazyProseThead, LazyProseTr, LazyProseUl, LazyIcon, LazyNuxtIcon } from '#components'
const lazyGlobalComponents = [
  ["AppServices", LazyAppServices],
["Breadcrumbs", LazyBreadcrumbs],
["GetStartedBtn", LazyGetStartedBtn],
["GuideSection", LazyGuideSection],
["GuideText", LazyGuideText],
["Logo", LazyLogo],
["LogoChip", LazyLogoChip],
["MarketplaceLink", LazyMarketplaceLink],
["RouteLink", LazyRouteLink],
["ShowUsLove", LazyShowUsLove],
["VArrowBtn", LazyVArrowBtn],
["BlockComponent", LazyBlockComponent],
["HtmlBlock", LazyHtmlBlock],
["LocalComponentBlock", LazyLocalComponentBlock],
["PageContent", LazyPageContent],
["SectionBlock", LazySectionBlock],
["TextBlock", LazyTextBlock],
["BackgroundBlock", LazyBackgroundBlock],
["InfoCardBlock", LazyInfoCardBlock],
["EventBlock", LazyEventBlock],
["EventsBlock", LazyEventsBlock],
["GridBlock", LazyGridBlock],
["ImageBlock", LazyImageBlock],
["MediaBlock", LazyMediaBlock],
["VideoBlock", LazyVideoBlock],
["OverlayBlock", LazyOverlayBlock],
["ProductBlock", LazyProductBlock],
["ProductsBlock", LazyProductsBlock],
["RecipeBlock", LazyRecipeBlock],
["RecipesBlock", LazyRecipesBlock],
["ServiceProfileBlock", LazyServiceProfileBlock],
["ServiceProfilesBlock", LazyServiceProfilesBlock],
["SliderBlock", LazySliderBlock],
["ProseA", LazyProseA],
["ProseBlockquote", LazyProseBlockquote],
["ProseCode", LazyProseCode],
["ProseEm", LazyProseEm],
["ProseH1", LazyProseH1],
["ProseH2", LazyProseH2],
["ProseH3", LazyProseH3],
["ProseH4", LazyProseH4],
["ProseH5", LazyProseH5],
["ProseH6", LazyProseH6],
["ProseHr", LazyProseHr],
["ProseImg", LazyProseImg],
["ProseLi", LazyProseLi],
["ProseOl", LazyProseOl],
["ProseP", LazyProseP],
["ProsePre", LazyProsePre],
["ProseScript", LazyProseScript],
["ProseStrong", LazyProseStrong],
["ProseTable", LazyProseTable],
["ProseTbody", LazyProseTbody],
["ProseTd", LazyProseTd],
["ProseTh", LazyProseTh],
["ProseThead", LazyProseThead],
["ProseTr", LazyProseTr],
["ProseUl", LazyProseUl],
["Icon", LazyIcon],
["NuxtIcon", LazyNuxtIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
